/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { SearchIcon } from '../static/icons';

export const QuickSearch: React.FC<any> = (rest) => (
  <InputGroup mb={4}>
    <InputLeftElement pointerEvents="none">
      <SearchIcon />
    </InputLeftElement>
    <Input backgroundColor="hover" borderRadius="8px" {...rest} />
  </InputGroup>
);
